export const tariffTypeOptions = [
    "AD_HOC_PAYMENT",
    "REGULAR",
    "PROFILE_FAST",
    "PROFILE_CHEAP",
    "PROFILE_GREEN",
].map((value) => ({ label: value, value }));

export const currencyOptions = ["SEK", "EUR", "USD", "GBP"].map((value) => ({
    label: value,
    value,
}));

export const priceTypeOptions = [
    { value: "ENERGY", label: "Energy (kWh)" },
    { value: "TIME", label: "Charging time (hours)" },
    { value: "PARKING_TIME", label: "Parking time (hours)" },
    { value: "FLAT", label: "Flat fee" },
];

export const taxIncludedOptions = [
    { value: "NO", label: "NO" },
    { value: "YES", label: "YES" },
    { value: "N/A", label: "N/A" },
];

export const TAX_INCLUDED_LOCKED = "NO";

export const bookingOptions = [
    { value: "BOOKING", label: "BOOKING" },
    { value: "BOOKING_EXPIRES", label: "BOOKING_EXPIRES" },
    { value: "BOOKING_CANCELLATION_FEES", label: "BOOKING_CANCELLATION_FEES" },
    { value: "BOOKING_OVERTIME", label: "BOOKING_OVERTIME" },
];

/** OCPI DayOfWeek enum values (API/DB). Labels are for UI only. */
export const dayOfWeekOptions = [
    { value: "MONDAY", label: "Monday" },
    { value: "TUESDAY", label: "Tuesday" },
    { value: "WEDNESDAY", label: "Wednesday" },
    { value: "THURSDAY", label: "Thursday" },
    { value: "FRIDAY", label: "Friday" },
    { value: "SATURDAY", label: "Saturday" },
    { value: "SUNDAY", label: "Sunday" },
];

const legacyDayOfWeekToOcpi = {
    Monday: "MONDAY",
    Tuesday: "TUESDAY",
    Wednesday: "WEDNESDAY",
    Thursday: "THURSDAY",
    Friday: "FRIDAY",
    Saturday: "SATURDAY",
    Sunday: "SUNDAY",
    1: "MONDAY",
    2: "TUESDAY",
    3: "WEDNESDAY",
    4: "THURSDAY",
    5: "FRIDAY",
    6: "SATURDAY",
    7: "SUNDAY",
    0: "SUNDAY",
};

export function normalizeDayOfWeekValue(day) {
    if (day == null || day === "") return null;
    if (typeof day === "number" && legacyDayOfWeekToOcpi[day]) {
        return legacyDayOfWeekToOcpi[day];
    }
    const trimmed = String(day).trim();
    const upper = trimmed.toUpperCase();
    if (dayOfWeekOptions.some((o) => o.value === upper)) {
        return upper;
    }
    if (legacyDayOfWeekToOcpi[trimmed]) {
        return legacyDayOfWeekToOcpi[trimmed];
    }
    return null;
}

export function normalizeDayOfWeekList(days) {
    if (!Array.isArray(days)) return [];
    return [...new Set(days.map(normalizeDayOfWeekValue).filter(Boolean))];
}

export function getTariffTypeOptions(t) {
    return tariffTypeOptions.map((option) => ({
        ...option,
        label: t(`tariff.type.${option.value}`, { defaultValue: option.label }),
    }));
}

export function getPriceTypeOptions(t) {
    return priceTypeOptions.map((option) => ({
        ...option,
        label: t(`tariff.priceType.${option.value}`, { defaultValue: option.label }),
    }));
}

export function getTaxIncludedOptions(t) {
    return taxIncludedOptions.map((option) => ({
        ...option,
        label: t(`tariff.taxIncluded.${option.value}`, { defaultValue: option.label }),
    }));
}

export function getBookingOptions(t) {
    return bookingOptions.map((option) => ({
        ...option,
        label: t(`tariff.booking.${option.value}`, { defaultValue: option.label }),
    }));
}

export function getDayOfWeekOptions(t) {
    return dayOfWeekOptions.map((option) => ({
        ...option,
        label: t(`weekday.${option.value}`, { defaultValue: option.label }),
    }));
}

export function formatDayOfWeekLabel(value, t) {
    const ocpi = normalizeDayOfWeekValue(value);
    if (!ocpi) return value ?? "";
    const fallback = dayOfWeekOptions.find((o) => o.value === ocpi)?.label ?? ocpi;
    return t ? t(`weekday.${ocpi}`, { defaultValue: fallback }) : fallback;
}
